export class Cluster {
  id?: string;
  description: string;
  cluster_type_id?: string;
  cluster_type_code?: string;
  code?: string;
  cluster_type_description?: string;
  //type?: string;
}

export class ClusterHead {
  id?: string;
  date_start: string;
  date_end: string;
  description: string;
  depends_on_cluster_head_id?: number;
  exclude_cluster_head_id?: number;
  code?: string;
}

export class OChannel {
  id?: string;
  cluster_head_id: number
  conversion_code: string;
  description: string;
  ochannel_id?: any;
  icon_b64?: any;
  icon_url?: string;
  flg_direct_active: string;
}

export class CustomerCluster {
  id?: number;
  customerId: number;
  clusterHeadId: number;
  conversionCode: string;
  code: string;
  headDescription?: string;
  date_start?: Date;
  date_end?: Date;
  clusterType?: string;
  clusterDescription?: string;
  oChannelId?: number;
  headId?: number;
  channels?: any[];
  flgDeployed?: any;
  ochannelDescription?: string;
  clusterTypeDescription?: string;
  editableCluster?: boolean;
}

export interface CustomerClusterDataToSend {
  id?: number;
  customerId: number;
  clusterHeadId: number;
  cluster?: string;
  dtStart: string;
  dtEnd: string;
}



// WEBPACK FOOTER //
// ./src/app/models/loyalty-cluster.model.ts